import { RoastBatchParameterType } from 'fabscale-app/models/enums/roast-batch-parameter-type';
import { EnumBaseSearchMatcherHelper } from './-base';

export default class EnumSearchMatcherRoastBatchParameterTypeHelper extends EnumBaseSearchMatcherHelper<RoastBatchParameterType> {
  getLabel(option: RoastBatchParameterType) {
    return this.enumLabels.roastBatchParameterType(option);
  }
}
